import React, { useEffect, useRef } from 'react';
import './Hero.css';
import avatarHero from '../../assets/avatar-hero.png';
import resumePdf from '../../assets/Luigi Santiago Resume.pdf';
import linkedinIcon from '../../assets/socials/3d-icon-linkedin.png';
import githubIcon from '../../assets/socials/3d-icon-github.png';
import facebookIcon from '../../assets/socials/3d-icon-facebook.png';

const Hero = () => {
  const typingRef = useRef(null);

  useEffect(() => {
    if (!typingRef.current) return;

    const roles = [
      'Full-Stack Web Architectures',
      'Native Mobile Applications',
      'Java & Spring Enterprise APIs',
      'Scalable Cloud Systems'
    ];

    const typingSpeed = 70;
    const backSpeed = 35;
    const pause = 1600;
    const loopPause = 300;

    let roleIndex = 0;
    let charIdx = 0;
    let typing = true;
    let timer = null;

    const type = () => {
      const currentRole = roles[roleIndex];
      if (typing) {
        if (charIdx <= currentRole.length) {
          if (typingRef.current) {
            typingRef.current.textContent = currentRole.substring(0, charIdx);
            charIdx++;
            timer = setTimeout(type, typingSpeed);
          }
        } else {
          typing = false;
          timer = setTimeout(type, pause);
        }
      } else {
        if (charIdx >= 0) {
          if (typingRef.current) {
            typingRef.current.textContent = currentRole.substring(0, charIdx);
            charIdx--;
            timer = setTimeout(type, backSpeed);
          }
        } else {
          typing = true;
          roleIndex = (roleIndex + 1) % roles.length;
          timer = setTimeout(type, loopPause);
        }
      }
    };

    type();

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbar = document.querySelector('.navbar-island');
      const navbarHeight = navbar ? navbar.offsetHeight : 70;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight - 16;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-grid">
        {/* Left Column: Typography & CTAs */}
        <div className="hero-content">
          <div className="hero-status-badge animate-fade-in-down">
            <span className="status-dot"></span>
            <span>Available for new projects & roles</span>
          </div>

          <h1 className="hero-title animate-fade-in-up">
            Crafting digital products with <span className="hero-title-gradient">precision</span> & craft.
          </h1>

          <div className="hero-role-line animate-fade-in-up delay-1">
            <span className="hero-role-prefix">Specialized in </span>
            <span className="hero-typing-role" ref={typingRef}></span>
            <span className="typing-cursor">|</span>
          </div>

          <p className="hero-description animate-fade-in-up delay-2">
            Hi, I'm <strong>Luigi Santiago</strong> — a Software Developer focused on building high-performance web applications, native mobile systems, and scalable backend services with clean, modern architectures.
          </p>

          <div className="hero-actions animate-fade-in-up delay-3">
            <button onClick={() => scrollToSection('contact')} className="btn btn-primary hero-btn">
              <span>Get in touch</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
            <a
              href={resumePdf}
              className="btn btn-secondary hero-btn"
              download="Luigi-Santiago-Resume.pdf"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              <span>Download CV</span>
            </a>
          </div>

          <div className="hero-social-strip animate-fade-in-up delay-4">
            <span className="social-strip-label">Find me on</span>
            <div className="social-pill-group">
              <a
                href="https://github.com/Wigibles"
                className="social-pill"
                title="GitHub"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={githubIcon} alt="GitHub" className="social-pill-icon" />
                <span>GitHub</span>
              </a>
              <a
                href="https://www.linkedin.com/in/luigiatlinkdin/"
                className="social-pill"
                title="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="LinkedIn" className="social-pill-icon" />
                <span>LinkedIn</span>
              </a>
              <a
                href="https://www.facebook.com/luigisantiago231"
                className="social-pill"
                title="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookIcon} alt="Facebook" className="social-pill-icon" />
                <span>Facebook</span>
              </a>
            </div>
          </div>
        </div>

        {/* Right Column: Hero Visual Card */}
        <div className="hero-visual animate-fade-in-up delay-2">
          <div className="hero-avatar-card">
            <div className="avatar-ambient-glow"></div>
            <div className="avatar-frame">
              <img src={avatarHero} alt="Luigi Santiago" className="avatar-photo" />
            </div>
            <div className="avatar-meta-tag">
              <span className="meta-tag-dot"></span>
              <span>Luigi Santiago • Software Developer</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;